import { z } from 'zod';
import { ResultIdSchema } from './common.js';

/*
 * Chat próprio no navegador (ADR 0046): o que o navegador manda ao serviço. Quem pergunta, tenant e canal saem do token
 * e da rota, nunca do corpo. A resposta das perguntas vem em eventos (SSE), descritos em @lastrouter/viz.
 */

/** Configuração pública do login do chat (GET /api/chat/config): nada de segredo. */
export const ChatPublicConfigSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal('entra'),
    /** https://login.microsoftonline.com/<tenant> */
    authority: z.string().url(),
    client_id: z.string().min(1),
    scopes: z.array(z.string().min(1)).min(1),
    assistant_name: z.string(),
    accent_color: z.string(),
  }),
  /** Identidade de desenvolvimento (lastrouter dev-token): a tela pede o token gerado na máquina. Nunca em produção. */
  z.object({ mode: z.literal('dev'), assistant_name: z.string(), accent_color: z.string() }),
]);
export type ChatPublicConfig = z.infer<typeof ChatPublicConfigSchema>;

export const ChatMessageRequestSchema = z.object({
  /** Id da conversa gerado pelo navegador; o serviço o liga a quem perguntou. */
  conversation_id: z.string().regex(/^[A-Za-z0-9_-]{8,64}$/),
  question: z.string().trim().min(1).max(2000),
});
export type ChatMessageRequest = z.infer<typeof ChatMessageRequestSchema>;

export const ChatFeedbackRequestSchema = z.object({
  result_ids: z.array(ResultIdSchema).min(1).max(10),
  kind: z.enum(['useful', 'wrong']),
  comment: z.string().trim().max(2000).optional(),
});
export type ChatFeedbackRequest = z.infer<typeof ChatFeedbackRequestSchema>;
